const pad = (valor: number) => valor.toString().padStart(2, '0')

const decompor = (totalSegundos: number) => {
  const segundos = Math.max(0, Math.floor(totalSegundos))
  return {
    horas: Math.floor(segundos / 3600),
    minutos: Math.floor((segundos % 3600) / 60),
    segundos: segundos % 60,
  }
}

export const formatarRelogio = (totalSegundos: number) => {
  const { horas, minutos, segundos } = decompor(totalSegundos)
  return `${pad(horas)}:${pad(minutos)}:${pad(segundos)}`
}

/** Como {@link formatarRelogio}, mas omite as horas enquanto não houver ao menos uma. */
export const formatarRelogioCompacto = (totalSegundos: number) => {
  const { horas, minutos, segundos } = decompor(totalSegundos)
  return horas > 0
    ? `${horas}:${pad(minutos)}:${pad(segundos)}`
    : `${pad(minutos)}:${pad(segundos)}`
}
